<template>
  <div id="satellite">
    <section class="con1" :class="{on:classActive}">
      <div class="con1_bg"><img src="../../assets/image/con1_2.png" alt="Satellites"></div>
      <figure v-scrollanimation>
        <h3 data-lang="con_title_satellites">Satellites</h3>
        <p class="con1_1" data-lang="con_sub_title_satellites">A satellite is an object rotating around the earth in a circular or elliptical orbit. The satellite is launched by a launch vehicle and enters to a predetermined orbit to perform various missions. </p>
        <p class="con1_2" data-lang="con_text_satellites">The altitude of an orbit differs by the use of satellite. A high-resolution earth observation satellite capturing the details of the earth or an internet satellite constellation (ex. Starlink) providing a low latency internet service are found in the low earth orbit (250~2,000km), whereas a navigation satellite such as GPS rotate in the middle orbit (2,000~36,000km) to image the whole movement in the earth. Recently, about 2,600 operating satellites are found in space. The number is expected to multiply as the space market is being more diverse with increasing new private entrants. About 30% of the total satellites are EO satellites. Numerous commercial companies and entities have announced to form a EO mega-constellation to capture the earth in real time and provide a value-added service to the imageries. The imageries are processed with AI deep learning algorithms then used to provide solutions in different fields including fisheries, agriculture, land use, and urban planning. </p>
      </figure>
    </section>
  </div>
</template>

<script>
import $ from "jquery"

export default {
  name: "Satellites",
  data: ()=> ({
    myScroll: null,
    classActive: false,
  }),
  props: ['nowScroll'],
  watch: {
    nowScroll(newData) {
      this.textToggle(newData)
    }
  },
  mounted() {
    this.myScroll = $('#satellite').offset().top
  },
  methods: {
    textToggle(data) {
      if(data >= (this.myScroll - 600) && data <= (this.myScroll + 600)) {
        this.classActive = true
      } else {
        this.classActive = false
      }
    }
  }
}
</script>

<style scoped>
</style>